import { useEffect, useRef, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { ChevronDownIcon, CoinsIcon, LogOutIcon } from "../Components/Icons";
import "./Topbar.css";

export default function Topbar({ credits, displayName, email }) {
  const { logout } = useAuth0();
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    if (!open) return;

    function onClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    function onEscape(event) {
      if (event.key === "Escape") setOpen(false);
    }

    document.addEventListener("mousedown", onClickOutside);
    document.addEventListener("keydown", onEscape);
    return () => {
      document.removeEventListener("mousedown", onClickOutside);
      document.removeEventListener("keydown", onEscape);
    };
  }, [open]);

  return (
    <header className="topbar">
      {/* Credits hidden for now — reinstate when AI generation ships.
      <span className="topbar__credits" title="Generation credits remaining">
        <CoinsIcon className="topbar__credits-icon" />
        {credits}
        <span className="topbar__credits-label">credits</span>
      </span>
      */}

      <div className="topbar__account" ref={menuRef}>
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-expanded={open}
          aria-haspopup="menu"
          className="topbar__account-trigger"
        >
          <span className="topbar__avatar">{displayName?.charAt(0).toUpperCase()}</span>
          <span className="topbar__name">{displayName}</span>
          <ChevronDownIcon className="topbar__chevron" />
        </button>

        {open ? (
          <div role="menu" className="topbar__menu">
            <div className="topbar__menu-header">
              <p className="topbar__menu-name">{displayName}</p>
              <p className="topbar__menu-email">{email}</p>
            </div>
            <button
              type="button"
              role="menuitem"
              onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
              className="topbar__logout"
            >
              <LogOutIcon className="topbar__logout-icon" />
              Log out
            </button>
          </div>
        ) : null}
      </div>
    </header>
  );
}